import React from "react";
import "../../../../styles/css/pg-product-list-placeholder-loading.min.css";

export default class PlaceHolder extends React.PureComponent {
  render() {
    return (
      <div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="col-md-3 col-sm-6 wow fadeInUp animated"
          data-wow-duration="300ms"
          data-wow-delay="0ms"
          //  style="visibility: visible; -webkit-animation-duration: 300ms; -webkit-animation-delay: 0ms;"
        >
          <div className="ph-item">
            <div className="ph-col-12">
              <div className="ph-row">
                <div className="ph-col-6 big"></div>
                <div className="ph-col-4 empty big"></div>
                <div className="ph-col-2 big"></div>
                <div className="ph-col-4"></div>
                <div className="ph-col-8 empty"></div>
                <div className="ph-col-6"></div>
                <div className="ph-col-6 empty"></div>
                <div className="ph-col-12"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
